// extracted by css-extract-rspack-plugin
export default {"copyright_override":"M9n9S","copyrightOverride":"M9n9S","#":"i2Gyj"};